import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Toast } from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from './pay.module.less';
import tools from '../../utils/tools';

import CountDown from './payComponent/countDown';

import {
  wxH5Pay,
  wxJsApiPay,
  getOrderDetail,
} from '../../service/chat-service';

// 图片资源
import payWechat from '../../public/images/icon_buy_pay_wechat.png';
import paySelected from '../../public/images/icon_payment_checkbox_selected.png';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

class Pay extends React.Component {
  constructor(props) {
    super(props);
    const orderId = tools.getQueryString('orderId') || null;
    this.state = {
      orderId,
      orderDetail: {},
    };
  }

  componentDidMount() {
    document.title = '支付订单';
    this.loadData();
  }

  loadData = () => {
    const { orderId } = this.state;
    getOrderDetail(orderId).then((data) => {
      const { orderVo } = data;
      this.setState({ orderDetail: orderVo });
    });
  };

  payMethods = () => {
    const { orderId } = this.state;
    if (tools.isWeixinCient()) {
      // 调用微信支付方法
      wxJsApiPay({ orderId, openid: localStorage.getItem('openId') }).then(
        (res) => {
          Toast.hide();
          if (res.code === 10000) {
            const payObj = res.data;
            this.onBridgeReady(payObj, orderId);
          } else {
            Toast.fail(res.message, 1);
          }
        },
      );
    } else {
      // 浏览器支付方法
      wxH5Pay({ orderId }).then((res) => {
        if (res.code === 10000) {
          Toast.hide();
          window.location.href = res.data.mweb_url;
        } else {
          Toast.hide();
          Toast.fail(res.message, 1);
        }
      });
    }
  };

  onBridgeReady = (obj, orderId) => {
    const { history } = this.props;
    const { orderDetail } = this.state;
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: obj.appId, // 公众号名称，由商户传入
        timeStamp: obj.timeStamp, // 时间戳，自1970年以来的秒数
        nonceStr: obj.nonceStr, // 随机串
        package: obj.package,
        signType: 'MD5', // 微信签名方式:
        paySign: obj.paySign, // 微信签名
      },
      (res) => {
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回
          // ok，但并不保证它绝对可靠。
          Toast.success('支付成功，正在转跳', 1);
          history.push(
            `/payResult?shareUserId=${orderDetail.shareUserId}&productId=${orderDetail.productId}&orderId=${orderId}`,
          );
        } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          Toast.fail('取消支付', 1);
        } else {
          Toast.fail('支付失败', 1);
        }
      },
    );
  };

  render() {
    const { orderDetail } = this.state;
    const price = orderDetail.orderAmount
      ? (orderDetail.orderAmount / 100).toFixed(2)
      : '0.00 ';
    return (
      <div className={styles.pay}>
        <header className={styles.pay_title}>支付订单</header>
        <CountDown />
        <p className={styles.pay_price}>
          ￥
          <span>{price}</span>
        </p>
        <div className={styles.pay_methods}>
          <p className={styles.left}>
            <img src={payWechat} alt="" />
            <span>微信支付</span>
          </p>
          <p className={styles.right}>
            <img src={paySelected} alt="" />
          </p>
        </div>
        <footer className={styles.footer}>
          <Button
            className={styles.btn}
            type="primary"
            inline
            size="small"
            onClick={this.payMethods}
          >
            确认支付
          </Button>
        </footer>
      </div>
    );
  }
}

Pay.propTypes = propTypes;

export default withRouter(Pay);
